import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../Modules/navbar.css";
const Navbar = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0)
}
  let navigate = useNavigate()
  return (
    <>
      <div class="container-fluid">
        <nav class="navbar navbar-expand-xl navbar-dark bg-dark">
          <Link class="navbar-brand" to='/' onClick={scrollToTop}>
            <img
              src="logo.png"
              width="95"
              height="66"
              style={{ borderRadius: "1000px" }}
              alt=""
            />
          </Link>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div
            class="collapse navbar-collapse justify-content-end"
            id="navbarSupportedContent"
            data-toggle="collapse"
            data-target="#navbar-collapse"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <ul class="navbar-nav">
              <li class="nav-item active px-2">
                <Link className="nav-link navhove" to='/' onClick={scrollToTop}>
                  Home <span class="sr-only">(current)</span>
                </Link>
              </li>
              
              <li class="nav-item active px-2">
                <Link class="nav-link navhove" to="/about"  onClick={scrollToTop}>
                  About Us
                </Link>
              </li>
              <li class="nav-item active px-2">
                <Link class="nav-link navhove" to="/products" onClick={scrollToTop}>
                  Our Products
                </Link>
              </li>             
              <li class="nav-item active px-2">
                <Link onClick={scrollToTop} class="nav-link navhove" to="/contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Navbar;
